import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useEarlyAccess } from "./EarlyAccessContext";

const links = [
  { label: "The Problem", href: "#manifesto" },
  { label: "For Builders", href: "#builders" },
  { label: "For Partners", href: "#partners" },
  { label: "Ecosystem", href: "#ecosystem" },
];

export default function Nav() {
  const { open } = useEarlyAccess();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
      className="fixed inset-x-0 top-0 z-50 flex justify-center px-2 sm:px-4 pt-2 sm:pt-4"
      data-testid="site-nav"
    >
      <nav
        className={`flex w-full max-w-6xl items-center justify-between rounded-full px-3 py-2 sm:px-5 sm:py-3 transition-all duration-500 ${
          scrolled
            ? "border border-[#e5e7eb] bg-white/80 shadow-[0_10px_40px_-18px_rgba(30,58,138,0.35)] backdrop-blur-xl"
            : "border border-transparent bg-transparent"
        }`}
      >
        <a href="#top" className="flex items-center gap-1.5 sm:gap-2.5" data-testid="nav-logo">
          <img
            src="/logo.png"
            alt="LintelGrid Logo"
            className="h-6 w-6 sm:h-8 sm:w-8 object-contain"
          />
          <div className="flex flex-col justify-center leading-none">
            <span className="text-[14px] sm:text-[17px] font-extrabold tracking-tight text-[#111827]">
              Lintel<span className="text-[#1e3a8a]">Grid</span>
            </span>
            <span className="text-[8px] sm:text-[10px] font-bold tracking-wider text-[#475569] uppercase mt-0.5">
              Proptech
            </span>
          </div>
        </a>

        <div className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-[#475569] transition-colors hover:text-[#1e3a8a]"
            >
              {l.label}
            </a>
          ))}
        </div>

        <button
          onClick={() => open("general")}
          className="btn-primary rounded-full px-2.5 py-1 text-[10px] font-semibold text-white transition-all sm:px-4 sm:py-2 sm:text-xs"
          data-testid="nav-join-button"
        >
          Join Early Access
        </button>
      </nav>
    </motion.header>
  );
}
